import React from "react";
import {ChipLabel} from "./index";

const StatusChip = ({status}) => {
    const statusData = {
        "Active Client": {
            class: "status-chip success",
            text: "Active"
        },
        "Payment Default": {
            class: "status-chip success",
            text: "Active"
        },
        "Partner": {
            class: "status-chip success",
            text: "Active"
        },
        "Team": {
            class: "status-chip success",
            text: "Active"
        },
        "Past Client": {
            class: "status-chip error",
            text: "Past"
        },
        "Pending Decision Client": {
            class: "status-chip warning",
            text: "Pending"
        }
    }

    return (<ChipLabel label={statusData[status]?.text} className={statusData[status]?.class}/>)
}

export default StatusChip;